import * as types from '../constants/ActionTypes';

export const agregarDetalle = detalle => dispatch => {
  // console.log("Detalle en el action: ");
  // console.log(detalle)
  dispatch({
    type: types.AGREGAR_DETALLE,
    payload: {
      detalle,
    },
  });
};

export const agregarDetalles = detalles => dispatch => {
  // console.log("Detalle en el action: ");
  // console.log(detalles)
  dispatch({
    type: types.AGREGAR_DETALLES,
    payload: {
      detalles,
    },
  });
};

export const sacarDetalle = _id => dispatch => {
  dispatch({
    type: types.ELIMINAR_DETALLE,
    payload: {
      _id,
    },
  });
};

// eslint-disable-next-line no-unused-vars
export const getDetalles = detalle => dispatch => {
  dispatch({
    type: types.GET_DETALLES,
  });
};

export const setDetalles = detalles => dispatch => {
  // console.log('SET DETALLES:::::::::: ');
  // console.log(detalles);
  dispatch({
    type: types.SET_DETALLES,
    payload: {
      detalles,
    },
  });
};
